import { RemoteAmendMeter } from "../../../../data/usecases/meter";
import { AmendMeter } from "../../../../domain/usecases/amend-meter";
import { makeApiUrl, makeAxiosHttpClient } from "../../http";

export const makeRemoteAmendMeter = (): AmendMeter =>
  new RemoteAmendMeter(
    makeApiUrl("/meters/amend-meter"),
    makeAxiosHttpClient()
  );
